// Only new, server-selected generations opt into the delivery contract. Existing
// private works and every video model keep their original behavior.
export const OUTPUT_REVIEW_VERSION = 'botgo-output-review-v1';
export const OUTPUT_REVIEW_MODELS = Object.freeze([
  'botgo-image-2.5-flash', 'botgo-image-2',
]);

export const OUTPUT_REVIEW_BLOCKED = 'Generated content was blocked by content moderation. Your credits have been refunded.';
export const OUTPUT_REVIEW_UNAVAILABLE = 'We could not complete the generated content check. Your credits have been refunded. Please try again.';

export function requiresOutputReview(record) {
  const selection = record?.metadata?.inputContentReview;
  return OUTPUT_REVIEW_MODELS.includes(record?.modelKey)
    && selection?.outputReviewVersion === OUTPUT_REVIEW_VERSION
    && selection?.outputReviewRequired === true
    && selection?.noContentFiltering === false;
}

export function hasOutputReview(record) {
  return requiresOutputReview(record) && Boolean(record.metadata?.outputContentReview);
}

export function outputIsUndelivered(record) {
  return requiresOutputReview(record) && record.metadata?.outputContentReview?.state !== 'passed';
}

// A pending candidate lives only in the private persistence queue, never in an
// owner-visible URL/key or provider response. The worker attaches it after pass.
export function holdOutputDelivery(plan, { resourceType, modelKey, metadata }) {
  if (!requiresOutputReview({ modelKey, metadata })) return plan;
  if (!plan.job) throw new Error('OUTPUT_REVIEW_PERSISTENCE_REQUIRED');
  return {
    ...plan,
    storageFields: {
      ...plan.storageFields,
      status: 'processing', storageStatus: 'pending',
      sourceUrl: null, storageKey: null, storageProvider: null,
      ...(resourceType === 'image' ? { imageUrl: null } : { videoUrl: null, openaiUrl: null }),
      thumbnailUrl: null,
      metadata: {
        ...metadata, mediaFingerprint: null,
        delivery: { ...metadata?.delivery, progress: null },
        outputContentReview: { version: OUTPUT_REVIEW_VERSION, state: 'pending' },
      },
    },
  };
}

// Keep diagnostic/provider payloads private while delivery is held. In particular
// a webhook payload can contain the same output URL that the top-level hides.
export function sanitizeOutputDelivery(record) {
  if (!outputIsUndelivered(record)) return record;
  return {
    ...record, imageUrl: null, videoUrl: null, thumbnailUrl: null, openaiUrl: null,
    sourceUrl: null, storageKey: null,
    metadata: { outputContentReview: { state: record.metadata?.outputContentReview?.state || 'pending' },
      ...(record.metadata?.failure?.error?.code?.startsWith('output_content_moderation_')
        ? { failure: { error: { code: record.metadata.failure.error.code, message: record.metadata.failure.error.message } } } : {}),
    },
  };
}
